module.exports = __webpack_public_path__ + "static/media/feed.9e41e3d8.svg";